import dayjs from 'dayjs';

import { formatAvailability } from 'FRONTEND/utils/backendApi/availabilityApi';
import { BOOTH_TELECONSULTATION, SLOT_STATUS_FREE, VIDEO_CONSULTATION } from 'FRONTEND/utils/constants';
import { apiStatusError, fetchError } from 'FRONTEND/utils/errors';
import { API_SLOT_PATH } from 'FRONTEND/utils/routes';


/**
 * Get timeslots for given experts.
 * If multiple experts are specified, it will return timeslots on which all of them are available.
 * If no expert is specified, it will return individual timeslots for all experts across all tenants of the user.
 **/

export async function getSlots({ expertIdList = [], startDate, status = SLOT_STATUS_FREE, appointmentType, canAcceptPayment }) {
  const formattedStartDate = dayjs(startDate).format('YYYY-MM-DD');
  try {
    const searchParams = new URLSearchParams({ start: formattedStartDate, status });
    if (appointmentType) {
      searchParams.append('schedule.extension', 'AppointmentTypes');
      searchParams.append('schedule.extension.valueString', appointmentType === BOOTH_TELECONSULTATION ? VIDEO_CONSULTATION : appointmentType);
    }
    expertIdList.forEach((expertId) => {
      searchParams.append('schedule.actor', `Practitioner/${expertId}`);
    });

    if (canAcceptPayment) {
      searchParams.append('can-accept-payments', '1');
    }

    const response = await fetch(`${API_SLOT_PATH}?${searchParams}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }).then((data) => {
      apiStatusError({ response: data });
      return data.json();
    });

    return response.entry.map((slot) => {
      const availability = formatAvailability(slot.resource.schedule);
      return {
        availabilityId: slot.resource.schedule.id,
        start: slot.resource.start,
        end: slot.resource.end,
        status: slot.resource.status,
        appointmentTypeList: availability.typeList,
      };
    });
  } catch (error) {
    throw fetchError({ error });
  }
}
// Get list of timeslots for a given location,
// where its station and at least one user of the same tenant are available.
export const getLocationSlots = async({ locationId, startDate, endDate, appointmentType, status = SLOT_STATUS_FREE, canAcceptPayment }) => {
  const formattedStartDate = dayjs(startDate).format('YYYY-MM-DD');
  const formattedEndDate = dayjs(endDate).format('YYYY-MM-DD');
  try {
    const searchParams = new URLSearchParams({ start: formattedStartDate, end: formattedEndDate, status });
    if (appointmentType) {
      searchParams.append('schedule.extension', 'AppointmentTypes');
      searchParams.append('schedule.extension.valueString', appointmentType);
    }

    if (canAcceptPayment) {
      searchParams.append('can-accept-payments', '1');
    }

    const response = await fetch(`/api/slots/for-location/${locationId}?${searchParams}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }).then((data) => {
      apiStatusError({ response: data });
      return data.json();
    });

    return response.entry.map((slot) => {
      const availability = formatAvailability(slot.resource.schedule);
      return {
        availabilityId: slot.resource.schedule.id,
        start: slot.resource.start,
        end: slot.resource.end,
        status: slot.resource.status,
        appointmentTypeList: availability.typeList,
        actorType: availability.actorType,
        actorId: availability.actorId,
      };
    });
  } catch (error) {
    throw fetchError({ error });
  }
};

